import React, { useState } from "react";
import cod from "../../Asset/payement/cod.png";
import upi from "../../Asset/payement/upi.png";
import wallet from "../../Asset/payement/wallet.png";
import { useLocation } from "react-router-dom";

const PaymentMethod = ({ setPaymentmethod, paymentmethod }) => {
  
  const Location = useLocation()

  console.log("location",Location)
  return (
    <div className="w-full flex flex-col">
      <div className="w-full">
        <span className="text-textColor text-base title1 font-semibold ">
          Payment Method
        </span>
      </div>
      <div className="mt-4 bg-[#F6F7F3] rounded-2xl px-4 pt-4 pb-3 ">

        {Location?.pathname !=="/subscribe" &&
        <div
          className={`w-full flex gap-2 justify-between p-2 items-center cursor-pointer rounded-2xl
        ${
          paymentmethod === "cod"
            ? "bg-[#dce5d6] text-gray-600 "
            : "text-textColor hover:bg-[#dce5d6] "
        }`}
          onClick={() => {
            setPaymentmethod("cod");
          }}
        >
          <div className="flex gap-6 w-full items-center">
            <input
              type="radio"
              checked={paymentmethod === "cod"}
              className="cursor-pointer"
              style={{ accentColor: "#5D6D56" }}
            />
            <div className="flex flex-col">
              <span className="font-semibold text-[15px] title1">Cash On Delivery</span>
              <span className="text-[12px]">
                Hand over cash to our delivery boy
              </span>
            </div>
          </div>
          <div>
            <div className="w-full">
              <img src={cod} alt="COD" className="w-full object-cover" />
            </div>
          </div>
        </div>}
        {Location?.pathname !=="/subscribe" &&
        <div
          className={`w-full flex gap-2 justify-between p-2 items-center cursor-pointer mt-4 rounded-2xl
        ${
          paymentmethod === "online"
            ? "bg-[#dce5d6] text-gray-600  "
            : "text-textColor hover:bg-[#dce5d6] "
        } rounded-2xl`}
          onClick={() => {
            setPaymentmethod("online");
          }}
        >
          <div className="flex gap-6 w-full items-center">
            <input
              type="radio"
              className=""
              checked={paymentmethod === "online"}
              style={{ accentColor: "#5D6D56" }}
            />
            <div className="flex flex-col">
              <span className=" font-semibold text-[15px] title1">Pay Now</span>
              <span className="text-[12px] ">
                Pay online for hassle free delivery experience
              </span>
            </div>
          </div>
          <div>
            <div className="full">
              <img src={upi} className="w-full object-cover" alt="" />
            </div>
          </div>
        </div>}
 
        <div
          className={`w-full flex gap-2 justify-between p-2 items-center cursor-pointer mt-4 rounded-2xl
        ${
          paymentmethod === "wallet"
            ? "bg-[#dce5d6] text-gray-600  "
            : "text-textColor hover:bg-[#dce5d6]"
        }`}
          onClick={() => {
            setPaymentmethod("wallet");
          }}
        >
          <div className="flex gap-6 w-full items-center">
            <input
              type="radio"
              className=""
              checked={paymentmethod === "wallet"}
              style={{ accentColor: "#5D6D56" }}
            />

            <div className="flex flex-col">
              <span className=" font-semibold text-[15px] title1">Wallet</span>
              <span className="text-[12px] title1">Available balance ₹539</span>
            </div>
          </div>
          <div>
            <div className="full">
              <img src={wallet} className="w-full object-cover" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
